<div class="clearfix container-box details-box">
  <div class="box-body">
    <div class="table-holder table-responsive">
      <table class="table table-default table-striped" [hidden]="isEmptyTable$ | async" [class.loading-section]="isUpdating$ | async">
        <mat-table #table
                   matSort
                   [dataSource]="dataSource">

          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="onToggleAll($event.checked)"
                            [checked]="isAllSelected">
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="onToggle(element, $event.checked)"
                            [checked]="element.selected">
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.name"
                                matTooltipPosition="above"
                                matTooltipClass="text-center">{{element.name | truncate:45}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef> Description</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <td class="desc">
                <i class="fas fa-bed"></i>
                <strong>{{element.bedrooms || 0}}</strong>
                <span class="sptr">|</span>
                <i class="fas fa-bath"></i>
                <strong>{{element.bathrooms || 0}}</strong>
                <span class="sptr">|</span>
                <span>{{element.type}}</span>
              </td>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef> Phone</mat-header-cell>
            <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.phone"
                                matTooltipPosition="above"
                                matTooltipClass="text-center">{{element.phone | truncate:16}}</span></mat-cell>
          </ng-container>

          <ng-container matColumnDef="cityView">
            <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
            <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.cityView"
                                matTooltipPosition="above"
                                matTooltipClass="text-center">{{element.cityView | truncate:16}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="countryView">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
            <mat-cell *matCellDef="let element">
                          <span [matTooltip]="element.countryView"
                                matTooltipPosition="above"
                                matTooltipClass="text-center">{{element.countryView | truncate:16}}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onOpenRental(row)"
                   class="clickable"></mat-row>
        </mat-table>

        <mat-paginator #paginator
                       [length]="dataSource?.data?.length"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
                       [showFirstLastButtons]="true">
        </mat-paginator>
      </table>
      <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
    </div>
  </div>
</div>
